import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'

const gdo_resources = {
  en: {
    ...contactInfo_en,
  },
  fr: {
    ...contactInfo_fr,
  },
}

export default gdo_resources
